import * as React from "react";
import {connect, Dispatch} from "react-redux";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import {RootState} from "../../../store/reducer/root/RootState";
import {updateJobType} from "../../../store/action/jobType/jobType";
import JobType from "../../../model/job/JobType";
import {none, option, Option} from "ts-option";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import Loading from "../../ui/loading/Loading";
import JobTypesTable from "./JobTypesTable";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import EditJobTypeModal from "./modal/EditJobTypeModal";
import {fetchActivityTemplates} from "../../../store/action/survey/survey";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {toKeyIndexedObject} from "../../../utils/ArrayUtils";

interface ReduxProps {
	/**
	 * All job types.
	 */
	jobTypes: JobType[];
	/**
	 * All activity templates
	 */
	activityTemplates: Option<DictionaryItem[]>;
}

interface DispatchProps {
	/**
	 * Update job type.
	 * @param {string} name
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateJobType: (jtId: string, jobType: JobType, onSuccess: OnSuccess, onFailure: OnFailure) => void;

	/**
	 * Fetch activity templates
	 */
	fetchActivityTemplates: () => void
}

type Props = ReduxProps & DispatchProps;

interface IComponentState {
	/**
	 * Lead status to edit
	 */
	editedJobType: Option<JobType>;
	/**
	 * All activity templates as a map
	 */
	activityTemplatesMap: { [key: string]: DictionaryItem }
}

/**
 * Job type config view.
 */
class JobTypesList extends React.Component<Props, IComponentState> {

	constructor(props: Props) {
		super(props);
		this.state = {
			editedJobType: none,
			activityTemplatesMap: toKeyIndexedObject(props.activityTemplates.getOrElse([]), a => a.id)
		};
		this.props.fetchActivityTemplates();
		this.renderEditItemModal = this.renderEditItemModal.bind(this);
	}

	componentWillReceiveProps(nextProps: Readonly<Props>): void {
		if (this.props.activityTemplates.getOrElse([]).length != nextProps.activityTemplates.getOrElse([]).length) {
			this.setState({
				activityTemplatesMap: toKeyIndexedObject(nextProps.activityTemplates.getOrElse([]), a => a.id)
			})
		}
	}

	render() {
		return (
			<React.Fragment>
				<PageHeaderView header={"Job Types"}/>
				<PageContentView>
					<Loading isLoading={this.props.jobTypes.length === 0}>
						<JobTypesTable activityTemplatesMap={this.state.activityTemplatesMap}
									   jobTypes={this.props.jobTypes}
									   onRowClick={(item) => this.setState({editedJobType: option(item)})}/>
					</Loading>
					{this.renderEditItemModal()}
				</PageContentView>
			</React.Fragment>
		);
	}


	/**
	 * Render modal.
	 */
	renderEditItemModal() {
		if (this.state.editedJobType.isDefined) {
			return (
				<EditJobTypeModal editedJobType={this.state.editedJobType.get}
								  onClose={() => this.setState({editedJobType: none})}/>
			);
		}
	}
}

function mapStateToProps(state: RootState) {
	return {
		jobTypes: [].concat(state.jobType.jobTypes.getOrElse([])),
		activityTemplates: state.survey.activityTemplates,
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchActivityTemplates: () => dispatch(
			fetchActivityTemplates(() => {}, (err) => notifyBugsnagAndShowToast(err, "Fetch activity templates"))),
		updateJobType: (jtId: string, jobType: JobType, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(updateJobType(jtId, jobType, onSuccess, onFailure))
	}
}

export default connect<ReduxProps, DispatchProps, null>(mapStateToProps, mapDispatchToProps)(JobTypesList)